import React, { useEffect } from 'react';
import { useParticleEffects } from '@/hooks/useParticleEffects';
import '@/styles/effects.css';

interface EffectsCanvasProps {
  width?: number;
  height?: number;
  className?: string;
}

// ETC identity: green + teal only.
const GREEN = '#00ff88';
const TEAL = '#14b8a6';

export const EffectsCanvas: React.FC<EffectsCanvasProps> = ({
  width = 800,
  height = 600,
  className = '',
}) => {
  const { canvasRef, createExplosion, createTrail } = useParticleEffects();

  useEffect(() => {
    const handleClick = (e: Event) => {
      const me = e as MouseEvent;
      createExplosion(me.clientX, me.clientY, GREEN);
    };

    const handleHover = (e: Event) => {
      const me = e as MouseEvent;
      createTrail(me.clientX, me.clientY, TEAL);
    };

    // Delegate from the document so nodes added/removed dynamically are covered
    // and listeners are always cleaned up safely.
    const isNodeTarget = (target: EventTarget | null): boolean =>
      target instanceof Element &&
      !!target.closest('.node-card, .netmap-node');

    const onDocClick = (e: MouseEvent) => {
      if (isNodeTarget(e.target)) handleClick(e);
    };
    const onDocOver = (e: MouseEvent) => {
      if (isNodeTarget(e.target)) handleHover(e);
    };

    document.addEventListener('click', onDocClick);
    document.addEventListener('mouseover', onDocOver);

    return () => {
      document.removeEventListener('click', onDocClick);
      document.removeEventListener('mouseover', onDocOver);
    };
  }, [createExplosion, createTrail]);

  return (
    <canvas
      ref={canvasRef}
      width={width}
      height={height}
      className={`effects-canvas ${className}`}
    />
  );
};
